import { render, staticRenderFns } from "./allocationPlan.vue?vue&type=template&id=52b03805&"
import script from "./allocationPlan.vue?vue&type=script&lang=js&"
export * from "./allocationPlan.vue?vue&type=script&lang=js&"
import style0 from "./allocationPlan.vue?vue&type=style&index=0&id=52b03805&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports